import { useField } from 'react-final-form';

import { Group, Input, InputAddon, InputGroup, InputProps } from '@oaknorth/component-core-v2';

import { FormFieldWrapper } from './FormFieldWrapper';
import { FormFieldProps } from './types';

export interface InputFieldProps extends FormFieldProps, Omit<InputProps, 'onChange'> {
  rightElement?: string | JSX.Element;
  rightAddOn?: JSX.Element;
  onChange?: (newValue: string) => void;
}

export const InputField = ({
  fieldName,
  labelText,
  helperText,
  rightElement,
  rightAddOn,
  onChange,
  'data-testid': testId,
  ...props
}: InputFieldProps) => {
  const {
    input,
    meta: { error, touched },
  } = useField<string | null | undefined>(fieldName);

  return (
    <FormFieldWrapper
      fieldName={fieldName}
      labelText={labelText}
      helperText={helperText}
      error={error}
      touched={touched}
      data-testid={testId}
      disabled={props.disabled}
    >
      <Group attached width="100%">
        <InputGroup endElement={rightElement} width="100%">
          <Input
            {...input}
            {...props}
            value={input.value || ''}
            id={fieldName}
            onChange={(event) => {
              input.onChange(event);
              onChange?.(event.target.value);
            }}
            autoComplete="off"
          />
        </InputGroup>
        {rightAddOn && <InputAddon pointerEvents="none">{rightAddOn}</InputAddon>}
      </Group>
    </FormFieldWrapper>
  );
};
